import { convertToDefaultDateFormat } from "@/util"

export class CourseDate {
  constructor(item) {
    this.title = item === null ? 'Names' : convertToDefaultDateFormat(item)
    this.value = item === null ? 'null' : item
  }
}